import Mapbox from 'index.vue';
import { BaseFeatureLayer } from './baseFeatureLayer';
export class PoisInRangeLayer extends BaseFeatureLayer {
    constructor(mapboxInstance: InstanceType<typeof Mapbox>) {
        super(mapboxInstance, '', 'pois-in-range-layer', 'pois-in-range-source', 'symbol', {
            'icon-image': ['get', 'url'],
            'icon-size': ['/', ['get', 'size'], 1],
            'icon-allow-overlap': true,
            'icon-anchor': 'top-left',
            'icon-offset': [-26, -26],
            'symbol-sort-key': ['get', 'zIndex'],
        }, {
            'icon-opacity': 0.75, // <- Set opacity here (0 = fully transparent, 1 = fully opaque)
        },true); 
    }
    public DataChanged = () => {
        const uniqueUrls = new Set<string>();
        this.mapboxInstance.poisInRange.forEach((poiSet: any) => {
            const url = '/api/models/' + this.mapboxInstance.model.id + '/poisets/' + poiSet.id + '/logo';
            uniqueUrls.add(url);
        });
        const loadImagePromises = super.LoadImages(uniqueUrls);
        const features: any[] = [];
        this.mapboxInstance.poisInRange.forEach((poiSet: any) => {
            if (this.mapboxInstance.poisInRangeFieldState[poiSet.name.toLowerCase()] == false || !this.mapboxInstance.poisInRangeFieldState[poiSet.name.toLowerCase()]) {
                const url = '/api/models/' + this.mapboxInstance.model.id + '/poisets/' + poiSet.id + '/logo';
                poiSet.pois.forEach((poi: any) => {
                    features.push({
                        type: 'Feature',
                        geometry: {
                            type: 'Point',
                            coordinates: [poi.longitude, poi.latitude] as [number, number],
                        },
                        properties: { url: url, size: 0.65, zIndex: 1, title: poi.name }
                    })
                });
            }
        });
        (async () => {
            await Promise.all(loadImagePromises);
            super.SetFeatures(features);
        })();
    };
}